export const RECORD_AUTH_USER = 'RECORD_AUTH_USER'
export const RECORD_AUTH_MENUS = 'RECORD_AUTH_MENUS'
export const RECORD_AUTH_PATH = 'RECORD_AUTH_PATH'
export const RECORD_AUTH_LOGOUT = 'RECORD_AUTH_LOGOUT'

export const RECORD_GLOBAL_USER = 'RECORD_GLOBAL_USER'
export const RECORD_GLOBAL_MENUS = 'RECORD_GLOBAL_MENUS'
export const RECORD_GLOBAL_COOKIE = 'RECORD_GLOBAL_COOKIE'
export const RECORD_GLOBAL_PEOPLE = 'RECORD_GLOBAL_PEOPLE'
export const RECORD_GLOBAL_JOBS = 'RECORD_GLOBAL_JOBS'
export const RECORD_GLOBAL_DEPARTMENTS = 'RECORD_GLOBAL_DEPARTMENTS'
export const RECORD_GLOBAL_RESUME = 'RECORD_GLOBAL_RESUME'
export const RECORD_GLOBAL_CHANNELS = 'RECORD_GLOBAL_CHANNELS'
export const RECORD_GLOBAL_PATH = 'RECORD_GLOBAL_PATH'
export const RECORD_GLOBAL_PREVILLAGE = 'RECORD_GLOBAL_PREVILLAGE'
export const RECORD_GLOBAL_CRUMBSECOND = 'RECORD_GLOBAL_CRUMBSECOND'
